import { cn } from "@/libs/utils";
import { BannerProps } from "@/services/banner/BannerService";
import Image from "next/image";
import { GamesButtonWebView } from "@/components/webview/games/shared/GamesButtonWebView";
import {
  Body4,
  Button2,
  Subtitle2,
} from "@/components/webview/games/typograpy/typograpy-webview";
import React from "react";
import { openBrowserWebView } from "@/components/webview/utils/webViewBridge";
import { LanguageCode, languageCodeToLanCode } from "@/utils/LocaleUtil";

export const GamePageImageBannerTemplateWebview = (
  props: BannerProps & { languageCode: LanguageCode },
) => {
  const code = languageCodeToLanCode(props.languageCode);
  return (
    <div className="relative block h-full max-h-[600px] min-h-[400px] w-full laptop:hidden">
      <Image
        width={360}
        height={400}
        sizes="100vw"
        src={props.webMobileImageUrl || ""}
        alt={"Banner Image"}
        className="relative h-full w-full rounded-lg object-cover"
      />
      <div className="absolute inset-0 mb-11 flex items-end justify-center px-2.5">
        <div className="flex flex-col items-center justify-center text-center">
          <Subtitle2 style={{ color: props.title.textColor }}>
            {props.title.text[code]}
          </Subtitle2>
          <Body4 className="mt-2" style={{ color: props.subtitle.textColor }}>
            {props.subtitle.text[code]}
          </Body4>
          <Paragraph
            className="mt-2"
            style={{ color: props.description.textColor }}
          >
            {props.description.text[code]}
          </Paragraph>

          {props.buttons
            .filter((button) => button.enabled)
            .map((button, index) => {
              return (
                <GamesButtonWebView
                  key={index}
                  onClick={() =>
                    openBrowserWebView({
                      directUrl: button.link || "",
                    })
                  }
                  className="mt-4"
                >
                  <Button2> {button.title[code]}</Button2>
                </GamesButtonWebView>
              );
            })}
        </div>
      </div>
    </div>
  );
};

const Paragraph = ({
  children,
  className,
  style,
}: React.PropsWithChildren & {
  className?: string;
  style?: React.CSSProperties;
}) => {
  if (!children) {
    return null;
  }
  return (
    <p
      className={cn(
        "line-clamp-4 text-ellipsis break-all text-sm laptop:line-clamp-3 laptop:text-lg",
        className,
      )}
      style={style}
    >
      {children}
    </p>
  );
};
